import { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // ✅ added
import '../Styles/UpcomingEvents.css';

const events = [
 {
  id: 1,
  title: "Diwali Connect & Foundation Day 2026",
  subtitle: '"Building Outstanding Workplaces Culture, People & Purpose"',
  date: "31st October, 2026 (Saturday)",
  time: "4:00 PM to 7:00 PM",
  location: "Chariot Beach Resort, Chennai",
  image: "/Diwali_event_img.png",
  route: "/viewmore-diw", // ✅ Diwali page route
  eventDate: "2026-10-31", // ✅ NEW: used for "days to the event" pill (YYYY-MM-DD)
 },
];
const moreEvents = [
 {
  id: 2,
  title: "Voices Of HR 2026 By Outstanding Workplaces",
  subtitle: '"Where Culture Comes Alive Through Conversations."',
  date: "18th April,2026 (saturday)",
  time: "10:00 am - 1:00pm",
  location: "Bloom Hub Hotel, Guindy, Chennai.",
  image: "/assets/upcoming.png",
  route: "/view-more-1", // ✅ same route as before
 },
 {
  id: 3,
  title: "Outstanding Workplaces Conference",
  subtitle: '"Building a People-Centric Culture : Strategies for Success"',
  date: "11th October,2025 (saturday)",
  time: "10:00 am - 1:00pm",
  location: "Bloom Hub Hotel, Guindy, Chennai.",
  image: "/assets/event_1.png",
  route: "/view-more", // ✅ same route as before
 },
];

/* ✅ NEW: calculates days left from today to the event date */
function getDaysLeft(eventDate) {
  if (!eventDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(eventDate + "T00:00:00");
  return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
}

function EventFlyer({ image }) {
   
  return (
    <div className="event-flyer">
      <img src={image} alt="Event Banner" />
    </div>
  );
}

function EventCard({ event, route }) {
  const navigate = useNavigate();

  const handleViewMore = () => {
    navigate(route); // ✅ dynamic route
  };

  /* ✅ NEW: countdown text */
  const daysLeft = getDaysLeft(event.eventDate);
  let countdownText = null;
  if (daysLeft !== null && daysLeft > 1) countdownText = `${daysLeft} days to the event`;
  else if (daysLeft === 1) countdownText = "1 day to the event";
  else if (daysLeft === 0) countdownText = "Event is today";

  return (
    
    <div className="event-card">
      <EventFlyer image={event.image} />

      <div className="event-details">

        {/* ✅ NEW: countdown pill above the title (only when eventDate is given) */}
        {countdownText && (
          <div className="event-countdown">
            <svg
              className="event-countdown-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="9" />
              <polyline points="12 7 12 12 15.5 14" />
            </svg>
            <span>{countdownText}</span>
          </div>
        )}

        <h2 className="event-title">
          {event.title.split("\n").map((line, i) => (
            <span key={i}>
              {line}
              <br />
            </span>
          ))}
        </h2>

        <p className="event-subtitle">{event.subtitle}</p>

        <div className="event-meta">
          {/* Date pill */}
          <div className="meta-pill1">
            <img src="/assets/calendar.png" alt="calendar" className="meta-icon" />
            {event.date}
          </div>

          {/* Time pill */}
          <div className="meta-pill2">
            <img src="/assets/time.png" alt="time" className="meta-icon" />
            {event.time}
          </div>
        </div>

        {/* Location pill */}
        <div className="meta-location">
          <img src="/assets/location.png" alt="location" className="meta-icon" />
          {event.location}
        </div>

        {/* ✅ BUTTON UPDATED */}
        <button className="view-btn" onClick={handleViewMore}>
          View More
        </button>

      </div>
    </div>
  );
}

export default function UpcomingEvents() {
  useEffect(() => {
      document.title = 'Upcoming Events | Outstanding Workplaces';
    }, []);
  return (
    <div className="page-wrapper">
      <h1 className="page-title">Upcoming Events</h1>

      {/* ✅ Each upcoming event in its own separate box */}
      {events.map((event, index) => (
        <div
          key={event.id}
          className="events-list"
          style={index !== events.length - 1 ? { marginBottom: "40px" } : undefined}
        >
          <EventCard event={event} route={event.route || "/view-more-1"} />
        </div>
      ))}

      {/* ✅ Previous Events heading now above the 2nd card */}
      <h1 className="page-title">Previous Events</h1>

      {/* ✅ Each previous event in its own separate box */}
      {moreEvents.map((event, index) => (
        <div
          key={event.id}
          className="events-list"
          style={index !== moreEvents.length - 1 ? { marginBottom: "40px" } : undefined}
        >
          <EventCard event={event} route={event.route || "/view-more"} />
        </div>
      ))}

    </div>
  );
}